const SidebarToggler = () => import('./SidebarToggler')
const CooperationModalButton = () => import('./CooperationModalButton')

export default function install(Vue) {
  Vue.component('sidebar-toggler', SidebarToggler)
  Vue.component('cooperation-modal-button', CooperationModalButton)
}
